export default {
  '@type': 'MerchantReturnPolicy',
  'applicableCountry': 'CH',
  'merchantReturnLink': 'https://www.timberland.ch/it-ch/assistenza-clienti/resi',
  'returnPolicyCategory': 'https://schema.org/MerchantReturnFiniteReturnWindow',
  'returnMethod': 'https://schema.org/ReturnByMail',
  'merchantReturnDays': 30
}
